const ExpandableNavTabs = {
  init() {
    if (this.loaded !== true) {
      this.loaded = false
    }
    if (!this.loaded) {
      return this.expandTabs()
    }
  },

  expandTabs() {
    this.loaded = true
    return $(document).on("click", ".nav-dropdown__toggle", function() {
      $(this)
        .toggleClass("is-open")
        .next(".nav-dropdown")
        .toggleClass("is-expanded")
    })
  },

  initialize() {
    $(document).on("turbolinks:load", () => Sprinkles.ExpandableNavTabs.init())
  }
}

export default ExpandableNavTabs
